import { render, staticRenderFns } from "./skills-left.vue?vue&type=template&id=2d2a1918"
import script from "./skills-left.vue?vue&type=script&lang=js"
export * from "./skills-left.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports